module.exports = __webpack_public_path__ + "img/videoicon.321ce60c.png";